import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { jewelryDatabase, collectionsDatabase } from "../data/jewelryData.ts"; // Importar dados centralizados

const Catalog: React.FC = () => {
  const [activeCategory, setActiveCategory] = useState<string>('aneis');
  const [sortBy, setSortBy] = useState<string>('lancamento');
  const [sortOrder, setSortOrder] = useState<string>('desc');

  // Função para converter data DD/MM/YYYY para objeto Date
  const parseDate = (dateString: string): Date => {
    const [day, month, year] = dateString.split('/').map(Number);
    return new Date(year, month - 1, day);
  };

  // Função para ordenar os itens
  const sortItems = (items: any[]) => {
    return [...items].sort((a, b) => {
      if (sortBy === 'nome') {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        if (sortOrder === 'asc') {
          return nameA.localeCompare(nameB);
        } else {
          return nameB.localeCompare(nameA);
        }
      } else if (sortBy === 'lancamento') {
        const dateA = parseDate(a.releaseDate);
        const dateB = parseDate(b.releaseDate);
        if (sortOrder === 'asc') {
          return dateA.getTime() - dateB.getTime();
        } else {
          return dateB.getTime() - dateA.getTime();
        }
      }
      return 0;
    });
  };

  // Filtrar joias por categoria usando os dados centralizados
  const filteredJewelry = jewelryDatabase.filter(
    jewelry => jewelry.category === activeCategory
  );

  // Aplicar ordenação
  const sortedJewelry = sortItems(filteredJewelry);
  const sortedCollections = sortItems(collectionsDatabase);

  return (
    <div className="container py-16">
      <h1 className="section-title">Catálogo Kronara</h1>

      {/* Filtros de categoria */}
      <div className="flex justify-center mb-8">
        <div className="inline-flex p-1 space-x-1 bg-prata-antiga rounded-lg">
          <button
            className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${
              activeCategory === 'aneis'
                ? 'bg-azul-majestoso text-white'
                : 'text-azul-majestoso hover:bg-azul-majestoso/10'
            }`}
            onClick={() => setActiveCategory('aneis')}
          >
            Anéis
          </button>
          <button
            className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${
              activeCategory === 'colecoes'
                ? 'bg-azul-majestoso text-white'
                : 'text-azul-majestoso hover:bg-azul-majestoso/10'
            }`}
            onClick={() => setActiveCategory('colecoes')}
          >
            Coleções
          </button>
        </div>
      </div>

      {/* Filtros de ordenação */}
      <div className="flex justify-center mb-12">
        <div className="flex flex-col sm:flex-row gap-4 items-center">
          <div className="flex items-center gap-2">
            <label htmlFor="sortBy" className="text-sm font-medium text-azul-majestoso">
              Ordenar por:
            </label>
            <select
              id="sortBy"
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="px-3 py-2 text-sm border border-azul-majestoso rounded-md focus:outline-none focus:ring-2 focus:ring-azul-majestoso focus:border-transparent"
            >
              <option value="lancamento">Lançamento</option>
              <option value="nome">Nome</option>
            </select>
          </div>
          <div className="flex items-center gap-2">
            <label htmlFor="sortOrder" className="text-sm font-medium text-azul-majestoso">
              Ordem:
            </label>
            <select
              id="sortOrder"
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
              className="px-3 py-2 text-sm border border-azul-majestoso rounded-md focus:outline-none focus:ring-2 focus:ring-azul-majestoso focus:border-transparent"
            >
              {sortBy === 'nome' ? (
                <>
                  <option value="asc">A-Z</option>
                  <option value="desc">Z-A</option>
                </>
              ) : (
                <>
                  <option value="desc">Mais recente</option>
                  <option value="asc">Mais antigo</option>
                </>
              )}
            </select>
          </div>
        </div>
      </div>

      {/* Catálogo de joias */}
      {activeCategory === 'aneis' && sortedJewelry.length > 0 ? (
        <div className="jewelry-gallery">
          {sortedJewelry.map((jewelry) => (
            <div key={jewelry.id} className="card">
              <Link to={`/joia/${jewelry.id}`} className="block relative overflow-hidden aspect-square group">
                <img
                  src={jewelry.images[0]} // Usar a primeira imagem como capa
                  alt={jewelry.name}
                  className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-110"
                />
                {/* Overlay opcional para indicar clicabilidade */}
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-opacity duration-300"></div>
              </Link>
              <div className="card-body text-center"> {/* Centralizar nome */}
                <h3 className="card-title">{jewelry.name}</h3>
                {/* Descrição e botão removidos */}
              </div>
            </div>
          ))}
        </div>
      ) : activeCategory === 'colecoes' && sortedCollections.length > 0 ? (
        <div className="jewelry-gallery">
          {sortedCollections.map((collection) => (
            <div key={collection.id} className="card">
              <Link to={`/colecao/${collection.id}`} className="block relative overflow-hidden aspect-square group">
                <img
                  src={collection.images[0]} // Usar a primeira imagem como capa
                  alt={collection.name}
                  className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-110"
                />
                {/* Overlay opcional para indicar clicabilidade */}
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-opacity duration-300"></div>
              </Link>
              <div className="card-body text-center"> {/* Centralizar nome */}
                <h3 className="card-title">{collection.name}</h3>
                {/* Descrição e botão removidos */}
              </div>
            </div>
          ))}
        </div>
      ) : activeCategory === 'colecoes' ? (
        <div className="p-8 text-center bg-prata-antiga rounded-lg">
          <h3 className="mb-4 text-xl font-bold text-azul-majestoso">Coleções em Breve</h3>
          <p className="mb-6">
            Estamos trabalhando em novas coleções exclusivas que serão lançadas em breve.
            Fique atento às nossas redes sociais para novidades!
          </p>
          <Link to="/contato" className="btn btn-primary">
            Receber Atualizações
          </Link>
        </div>
      ) : (
        <div className="p-8 text-center bg-perola rounded-lg">
          <h3 className="mb-4 text-xl font-bold text-azul-majestoso">Nenhuma peça encontrada</h3>
          <p>
            Não encontramos peças na categoria selecionada. Por favor, tente outra categoria
            ou entre em contato conosco para mais informações.
          </p>
        </div>
      )}
    </div>
  );
};

export default Catalog;

